import { login, logout } from '@/api/login'
import { getToken, setToken, removeToken, setUserTid, getUserTid, removeUserTid, setAccount, getAccount, removeAccount, getName, removeName, setName } from '@/utils/auth'
import md5 from 'md5'

const user = {
  state: {
    token: getToken(),
    user_tid: getUserTid(),
    account: getAccount(),
    name: getName()
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER_TID: (state, user_tid) => {
      state.user_tid = user_tid
    },
    SET_ACCOUNT: (state, account) => {
      state.account = account
    },
    SET_NAME: (state, name) => {
      state.name = name
    }
  },

  actions: {
    // 登录
    // commit 通过commit触发mutations，然后mutations修改state
    Login({ commit }, userInfo) {
      const mobile_phone  = userInfo.mobile_phone.trim()
      const password      = md5(userInfo.password)

      return new Promise((resolve, reject) => {
        login(mobile_phone, password).then(response => {
          const data = response.data
          // 登录成功后，将token保存到本地cookie
          setToken(data.token)
          setUserTid(data.user.tid)
          setAccount(data.user.account)
          setName(data.user.name)
          // 同时设置token到vuex的token
          commit('SET_TOKEN', data.token)
          commit('SET_USER_TID', data.user.tid)
          commit('SET_ACCOUNT', data.user.account)
          commit('SET_NAME', data.user.name)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout({commit, state}) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          commit('SET_TOKEN', null)
          commit('SET_USER_TID', null)
          commit('SET_ACCOUNT', null)
          commit('SET_NAME', null)
          removeToken()
          removeUserTid()
          removeAccount()
          removeName()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js